import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, NavLink } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel from "utils/DownloadExcel";
import { defaultOption } from "constants/ui/options";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getEmpFullNameTHByEmpData, getSupplierFullName, getSupplierMainContactFullName, mapMstToOptions, pageInitSize, pageSizeOptions } from "utils/HelperFunction";
import { nanoid } from "nanoid";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { getAllGroupOfSupplier } from "../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllNewPurchaseReq } from "../../redux/handlers/logic/getAllNewPurchaseReq.handler";
import moment from "moment";
import { NumericFormat } from "react-number-format";
export function PRList() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), data = _useState[0], setData = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), tab = _useState1[0], setTab = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), tab0 = _useState2[0], setTab0 = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), tab1 = _useState3[0], setTab1 = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), tab2 = _useState4[0], setTab2 = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), tab3 = _useState5[0], setTab3 = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), tab4 = _useState6[0], setTab4 = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), Alldata = _useState7[0], setAlldata = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), optionsDistributorgroup = _useState8[0], setOptionsDistributorgroup = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState9[0], setOptionsGroupOfSuplier = _useState9[1];
    var _useState10 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState10[0], setSelectedGroupOfSuplierID = _useState10[1];
    var _useState11 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState11[0], setGroupOfSupplier = _useState11[1];
    var _useState12 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), distributorgroup = _useState12[0], setDistributorgroup = _useState12[1];
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var getAllNewPurchaseReqReducer = useAppSelector(function(state) {
        return state.getAllNewPurchaseReqReducer;
    });
    // const getData = () => {
    //     fetch('/json/pr.json')
    //       .then((response) => response.json())
    //       .then((result) => {
    //         setData(result);
    //         setTab(result);
    //         const status0 = result.filter(item => item.status === 0 );
    //         const status1 = result.filter(item => item.status === 1 );
    //         const status2 = result.filter(item => item.status === 2 );
    //         const status3 = result.filter(item => item.status === 3 );
    //         const status4 = result.filter(item => item.status === 4 );
    //         setTab0(status0)
    //         setTab1(status1)
    //         setTab2(status2)
    //         setTab3(status3)
    //         setTab4(status4)
    //       })
    //       .catch((error) => console.log("error", error));
    // };
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var getData = function() {
        dispatch(getAllNewPurchaseReq({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        getData();
        loadAllMsts();
    }, []);
    var _useState13 = _sliced_to_array(useState(""), 2), filterText = _useState13[0], setFilterText = _useState13[1];
    var _useState14 = _sliced_to_array(useState(null), 2), btnempstatus = _useState14[0], setBtnempstatus = _useState14[1];
    useEffect(function() {
        setIsLoading(getAllGroupOfSupplierReducer.isFetching);
        if (getAllGroupOfSupplierReducer.data) {
            var options = mapMstToOptions(getAllGroupOfSupplierReducer.data.data);
            setOptionsGroupOfSuplier([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
    }, [
        getAllGroupOfSupplierReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllNewPurchaseReqReducer.isFetching);
        if (getAllNewPurchaseReqReducer.data) {
            var result = getAllNewPurchaseReqReducer.data.data;
            setData(result);
            setTab(result);
            var status1 = result.filter(function(item) {
                return item.dim_mst_new_status_id === 1;
            });
            var status2 = result.filter(function(item) {
                return item.dim_mst_new_status_id === 2;
            });
            var status3 = result.filter(function(item) {
                return item.dim_mst_new_status_id === 3;
            });
            var status6 = result.filter(function(item) {
                return item.dim_mst_new_status_id === 6;
            });
            var status7 = result.filter(function(item) {
                return item.dim_mst_new_status_id === 7;
            });
            setTab0(status1);
            setTab1(status2);
            setTab2(status3);
            setTab3(status6);
            setTab4(status7);
        }
    }, [
        getAllNewPurchaseReqReducer
    ]);
    var filteredItems = data.filter(function(item) {
        var docNumberMatches = item.doc_number && item.doc_number.toLowerCase().includes(filterText.toLowerCase());
        var supplierNameMatches = item.dimSupplierInformation && getSupplierFullName(item.dimSupplierInformation).toLowerCase().includes(filterText.toLowerCase());
        var supplierGroupMatches = !selectedGroupOfSuplierID || item.dimSupplierInformation && item.dimSupplierInformation.dimGroupOfSupplier && selectedGroupOfSuplierID === item.dimSupplierInformation.dimGroupOfSupplier.id;
        return (docNumberMatches || supplierNameMatches) && supplierGroupMatches;
    });
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่เอกสาร PR",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/purchase/requisition/edit/".concat(row.id),
                    target: "_blank",
                    children: row.doc_number
                });
            }
        },
        {
            field: "dimSupplierInformation",
            headerName: "ชื่อผู้จำหน่าย",
            flex: 1,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimSupplierInformation),
                            row.dimSupplierInformation.company_branch_name && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "(",
                                    row.dimSupplierInformation.company_branch_name || "-",
                                    ")"
                                ]
                            })
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "doc_issue_date",
            headerName: "วันที่ออกเอกสาร",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_issue_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "delivery_date",
            headerName: "วันที่จัดส่ง",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.delivery_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "dimMstPaymentType",
            headerName: "เงื่อนไขชำระเงิน",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimMstPaymentType ? row.dimMstPaymentType.name : "-"
                });
            }
        },
        {
            field: "qty_sum",
            headerName: "จำนวนสินค้า",
            width: 110,
            sortable: false
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            cellClassName: "d-flex justify-content-end",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        value: row.grand_total_price
                    })
                });
            }
        },
        {
            field: "dim_new_alldernow_emp_id",
            headerName: "ผู้สร้างเอกสาร",
            width: 220,
            align: "center",
            headerAlign: "center",
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: getEmpFullNameTHByEmpData(row.createdNewPrEmp)
                });
            }
        },
        {
            field: "dimMstNewStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            width: 190,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var statusID = row ? row.dimMstNewStatus.id : "";
                var statusName = row ? row.dimMstNewStatus.name : "";
                var color = "";
                var bg = "";
                if (statusID === 2) {
                    color = "#FDB428";
                    bg = "rgba(255, 246, 229, 1)";
                } else if (statusID === 3) {
                    color = "#FF731D";
                    bg = "rgba(255, 115, 29, 0.15)";
                } else if (statusID === 6) {
                    color = "rgba(114, 225, 40, 0.87)";
                    bg = "rgba(238, 251, 229, 1)";
                } else if (statusID === 1) {
                    color = "#747474";
                    bg = "#F4F4F4";
                } else {
                    color = "rgba(249, 80, 87, 1)";
                    bg = "rgba(255, 0, 0, 0.15)";
                }
                return statusID ? /*#__PURE__*/ _jsx("div", {
                    className: "px-3 py-1 mx-auto",
                    style: {
                        color: color,
                        backgroundColor: bg,
                        borderRadius: "20px"
                    },
                    children: statusName
                }) : /*#__PURE__*/ _jsx("div", {
                    children: "-"
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดซื้อ"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-2 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ใบขอซื้อ PR",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2 fw-bold tc-2",
                        style: {
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "ใบขอซื้อ PR"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == null ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(null);
                                    setData(tab);
                                },
                                children: [
                                    "ทั้งหมด",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 0 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(0);
                                    setData(tab0);
                                },
                                children: "แบบร่าง"
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 1 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(1);
                                    setData(tab1);
                                },
                                children: [
                                    "รออนุมัติ (",
                                    tab1.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 2 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(2);
                                    setData(tab2);
                                },
                                children: [
                                    "กำลังดำเนินการ (",
                                    tab2.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 3 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(3);
                                    setData(tab3);
                                },
                                children: [
                                    "เสร็จสิ้น (",
                                    tab3.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 4 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(4);
                                    setData(tab4);
                                },
                                children: "ยกเลิก"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "รายชื่อพนักงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-auto",
                                    style: {
                                        width: "220px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มผู้จัดจำหน่าย"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setSelectedGroupOfSuplierID(e.value);
                                                    setGroupOfSupplier(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsGroupOfSuplier,
                                                placeholder: "",
                                                value: groupOfSupplier
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/purchase/requisition/create",
                                    className: "btn btn btn-st-7 mb-2 px-4",
                                    children: "สร้างใบขอซื้อ"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                loading: getAllNewPurchaseReqReducer.isFetching,
                                getRowId: function(row) {
                                    return "ssdf".concat(row.id);
                                },
                                getRowHeight: function() {
                                    return "auto";
                                },
                                rows: filteredItems,
                                columns: columnsd,
                                // autoHeight={true}
                                initialState: {
                                    pagination: {
                                        paginationModel: {
                                            pageSize: pageInitSize
                                        }
                                    }
                                },
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    fontFamily: "Sarabun",
                                    fontSize: "18px",
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontFamily: "Sarabun",
                                        fontSize: "18px"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
}
